<div class="favoritos-topo">
  <h1 class="favoritos-titulo">
    Serviços favoritos
    <span class="favoritos-enfeites" aria-hidden="true">
      <span class="favoritos-enfeite favoritos-enfeite-amarelo"></span>
      <span class="favoritos-enfeite favoritos-enfeite-triangulo"></span>
      <span class="favoritos-enfeite favoritos-enfeite-azul"></span>
    </span>
  </h1>
  <p class="favoritos-subtitulo">
    Aqui estão os serviços que você marcou como favoritos para acessar com mais rapidez.
  </p>
</div>

@if (estado() === 'pronto') {
<div class="favoritos-busca">
  <i-lucide class="favoritos-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>

  <label class="favoritos-busca-label" for="favoritos-busca">Buscar nos meus serviços favoritos</label>
  <input #campoBusca id="favoritos-busca" class="favoritos-busca-input" type="search" autocomplete="off"
    placeholder="Buscar nos meus serviços favoritos..." [value]="termoBusca()" (input)="aoBuscar($event)" />

  @if (termoBusca()) {
  <button type="button" class="favoritos-busca-limpar" (click)="limparBusca()" aria-label="Limpar busca">
    <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
  </button>
  }
</div>
}

@if (dicaVisivel()) {
<div class="favoritos-dica" role="note">
  <span class="favoritos-dica-icone" aria-hidden="true">
    <i-lucide name="star" size="20"></i-lucide>
  </span>

  <div class="favoritos-dica-texto">
    <p class="favoritos-dica-titulo">Dica: seus favoritos, sempre à mão!</p>
    <p class="favoritos-dica-descricao">
      Adicione aos favoritos os serviços que você mais utiliza clicando no ícone de estrela ao lado de cada
      serviço, na tela de Serviços.
    </p>
  </div>

  <button type="button" class="favoritos-dica-fechar" (click)="fecharDica()" aria-label="Fechar dica">
    <i-lucide name="circle-x" size="20" aria-hidden="true"></i-lucide>
  </button>
</div>
}

@switch (estado()) {
@case ('sessao') {
<div class="favoritos-aviso" role="status">
  <p class="favoritos-aviso-texto">Sua sessão terminou. Entre novamente para ver os seus favoritos.</p>
  <a class="favoritos-explorar" routerLink="/login" [queryParams]="{ destino: '/area-cidadao?aba=favoritos' }">
    Entrar
  </a>
</div>
}

@case ('carregando') {
<p class="favoritos-aviso favoritos-aviso-texto" role="status" aria-live="polite">Carregando os seus favoritos...</p>
}

@case ('falha') {
<div class="favoritos-aviso" role="alert">
  <p class="favoritos-aviso-texto">
    Não foi possível carregar os seus favoritos agora. Tente novamente em instantes.
  </p>
  <button type="button" class="favoritos-explorar" (click)="recarregar()">Tentar novamente</button>
</div>
}

@case ('vazia') {
<div class="favoritos-vazio" role="status">
  <p class="favoritos-vazio-texto">Você ainda não marcou nenhum serviço como favorito.</p>
</div>
}

@case ('pronto') {
<div class="favoritos-barra">
  <div class="favoritos-barra-filtros">
    <label class="favoritos-seletor favoritos-seletor-destaque">
      <span class="favoritos-busca-label">Filtrar por categoria</span>
      <select class="favoritos-seletor-campo" [value]="categoriaFiltro()" (change)="aoFiltrarCategoria($event)">
        <option value="">Categorias</option>
        @for (categoria of categorias(); track categoria.id) {
        <option [value]="categoria.id">{{ categoria.titulo }}</option>
        }
      </select>
      <i-lucide name="chevron-down" size="16" aria-hidden="true"></i-lucide>
    </label>

    <label class="favoritos-seletor">
      <span class="favoritos-seletor-rotulo">Ordenar por:</span>
      <select class="favoritos-seletor-campo" [value]="ordenacao()" (change)="aoOrdenar($event)">
        <option value="acessos">Mais acessados</option>
        <option value="nome">Nome (A-Z)</option>
      </select>
      <i-lucide name="chevron-down" size="16" aria-hidden="true"></i-lucide>
    </label>
  </div>

  <div class="favoritos-visao" role="group" aria-label="Modo de exibição">
    <button type="button" class="favoritos-visao-botao" [class.favoritos-visao-botao-ativo]="!modoLista()"
      [attr.aria-pressed]="!modoLista()" (click)="definirModoLista(false)" aria-label="Ver em grade">
      <i-lucide name="layout-grid" size="18" aria-hidden="true"></i-lucide>
    </button>

    <button type="button" class="favoritos-visao-botao" [class.favoritos-visao-botao-ativo]="modoLista()"
      [attr.aria-pressed]="modoLista()" (click)="definirModoLista(true)" aria-label="Ver em lista">
      <i-lucide name="list" size="18" aria-hidden="true"></i-lucide>
    </button>
  </div>
</div>

@if (favoritos().length) {
<ul class="favoritos-lista" [class.favoritos-lista-modo-lista]="modoLista()">
  @for (favorito of favoritos(); track favorito.id) {
  @let categoria = categoriaExibida(favorito);
  <li class="favoritos-card" [attr.data-categoria-servicos-cor]="categoria.cor">
    <div class="favoritos-card-topo">
      <span class="favoritos-card-categoria">
        <span class="favoritos-card-ponto" aria-hidden="true"></span>
        {{ categoria.titulo }}
      </span>

      <button type="button" class="favoritos-card-estrela"
        [attr.aria-label]="'Remover ' + favorito.titulo + ' dos favoritos'" aria-pressed="true"
        [disabled]="estaRemovendo(favorito)" [attr.aria-busy]="estaRemovendo(favorito) || null"
        (click)="removerFavorito(favorito)">
        <i-lucide name="star" size="20" aria-hidden="true"></i-lucide>
      </button>
    </div>

    <span class="favoritos-card-icone" aria-hidden="true">
      <i-lucide [name]="categoria.icone" size="26"></i-lucide>
    </span>

    <h2 class="favoritos-card-titulo">{{ favorito.titulo }}</h2>
    <p class="favoritos-card-descricao">{{ favorito.descricao }}</p>

    <div class="favoritos-card-rodape">
      <span class="favoritos-card-total">Em {{ categoria.titulo }}</span>

      <a class="favoritos-card-acesso" [routerLink]="favorito.link" [attr.aria-label]="'Abrir ' + favorito.titulo">
        <i-lucide name="arrow-right" size="18" aria-hidden="true"></i-lucide>
      </a>
    </div>
  </li>
  }
</ul>
} @else {
<div class="favoritos-vazio">
  <p class="favoritos-vazio-texto" role="status">Nenhum favorito encontrado para a busca ou o filtro selecionado.</p>

  <button type="button" class="favoritos-explorar" (click)="limparFiltros()">Limpar filtros</button>
</div>
}
}
}

<section class="favoritos-cta" aria-labelledby="favoritos-cta-titulo">
  <span class="favoritos-cta-bolha" aria-hidden="true"></span>
  <span class="favoritos-cta-estrela" aria-hidden="true">
    <i-lucide name="star" size="40"></i-lucide>
  </span>

  <div class="favoritos-cta-texto">
    <h2 class="favoritos-cta-titulo" id="favoritos-cta-titulo">
      Não encontrou o serviço que usa com frequência?
    </h2>
    <p class="favoritos-cta-descricao">
      Explore todos os serviços disponíveis e favorite aqueles que fazem parte do seu dia a dia.
    </p>

    <a class="favoritos-explorar" routerLink="/servicos">
      Explorar todos os serviços
      <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
    </a>
  </div>
</section>
